'use client'

import { MessageSquare } from 'lucide-react'

import { DropdownMenuItem } from '~/components/component-library/Dropdown'
import { UpdateTransactionMemoDialog } from '~/components/smart-accounts/UpdateTransactionMemoDialog'
import { useAuth } from '~/context/AuthProvider'
import { OrgTransaction, OrgAssetTransfer } from '~/types'

export const UpdateTransactionMemoDropdownItem = ({
  transaction,
}: {
  transaction: OrgTransaction | OrgAssetTransfer
}) => {
  const { setGlobalModalState } = useAuth()

  return (
    <DropdownMenuItem
      onClick={() => {
        setGlobalModalState({
          isOpen: true,
          content: (
            <UpdateTransactionMemoDialog
              setIsOpen={() => {
                setGlobalModalState({
                  isOpen: false,
                  content: null,
                })
              }}
              transaction={transaction}
            />
          ),
        })
      }}
    >
      <MessageSquare />
      <div>{transaction.memo ? 'Edit' : 'Add'} memo...</div>
    </DropdownMenuItem>
  )
}
